import styles from "./styles.module.css";

export default function Basic({ options, onSelect, selected, category }) {
  return (
    <div className={styles.section}>
      <div className={styles.sectionTitle}>{category}</div>
      {options.map((x) => {
        return (
          <div
            key={x.code}
            onClick={() => onSelect(x)}
            className={
              selected.value === x.code
                ? styles.item + " " + styles.selected
                : styles.item
            }
          >
            {x.name}
          </div>
        );
      })}
    </div>
  );
}
